<div class="search-filter-outer-ctnr" [ngClass]="{'snp-custom-array': hideForCustomArray === true}">
    <div class="search-filter-ctnr container-fluid d-block d-md-flex justify-content-between">
        <div class="search-filter-container">
            <div class="tf-filter-mobile d-md-none">
                <div class="filters-btn" (click)="onFiltersClick()" [ngClass]="{'is-selected': isSelected === true}">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M5.48506 4.10999V1.35999H3.48506V4.04999C1.74112 4.45541 0.506836 6.00954 0.506836 7.79999C0.506836 9.59043 1.74112 11.1446 3.48506 11.55V22.64H5.48506V11.49C7.11752 11.0041 8.23669 9.50324 8.23669 7.79999C8.23669 6.09673 7.11752 4.5959 5.48506 4.10999ZM4.37506 9.66999C3.34228 9.66999 2.50506 8.83276 2.50506 7.79999C2.50506 6.76721 3.34228 5.92999 4.37506 5.92999C5.40783 5.92999 6.24506 6.76721 6.24506 7.79999C6.24506 8.29594 6.04804 8.77158 5.69735 9.12228C5.34665 9.47297 4.87101 9.66999 4.37506 9.66999ZM12.7551 12.14V1.35999H10.7551V12.14C9.06971 12.5894 7.89707 14.1157 7.89707 15.86C7.89707 17.6042 9.06971 19.1306 10.7551 19.58V22.64H12.7551V19.58C14.4404 19.1306 15.613 17.6042 15.613 15.86C15.613 14.1157 14.4404 12.5894 12.7551 12.14ZM11.7551 17.73C10.7223 17.73 9.88506 16.8928 9.88506 15.86C9.88506 14.8272 10.7223 13.99 11.7551 13.99C12.7878 13.99 13.6251 14.8272 13.6251 15.86C13.6251 16.3559 13.428 16.8316 13.0773 17.1823C12.7267 17.533 12.251 17.73 11.7551 17.73ZM20.6351 4.07999V1.35999H18.6351V4.07999C16.9497 4.52942 15.7771 6.05575 15.7771 7.79999C15.7771 9.54422 16.9497 11.0706 18.6351 11.52V22.64H20.6351V11.52C22.3204 11.0706 23.493 9.54422 23.493 7.79999C23.493 6.05575 22.3204 4.52942 20.6351 4.07999ZM19.6351 9.66999C18.8778 9.67404 18.1929 9.221 17.9003 8.52256C17.6077 7.82412 17.7652 7.01816 18.2992 6.48127C18.8332 5.94438 19.6383 5.78255 20.3383 6.07139C21.0383 6.36024 21.495 7.04273 21.4951 7.79999C21.4951 8.82887 20.6639 9.66448 19.6351 9.66999Z" fill="#0071D0"/>
                    </svg>
                    <span>Filters</span>
                </div>

                <div class="selected-item" [ngClass]="{'is-selected': isSelected === false}">
                    <span class="selected-items-label" (click)="onFiltersClick()">Filters</span>

                    <ng-container *ngFor="let item of renderedLabels; let i = index;">
                        <div class="badge">
                            {{ item.value.code | tfFiltersTruncate }}
                            <span (click)="deleteItem(item)" class="delete">
                                <svg width="10px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                    <line x1="19" y1="5" x2="5" y2="19" fill="#fff" stroke="#000" stroke-width="2" stroke-miterlimit="10" />
                                    <line x1="5" y1="5" x2="19" y2="19" fill="#fff" stroke="#000" stroke-width="2" stroke-miterlimit="10" />
                                </svg>
                            </span>
                        </div>
                    </ng-container>

                    <ng-container *ngIf="filters.length > 2">
                        <div class="grey-border" (click)="handleShowLessBtn()">
                            {{getMoreLabel()}}
                        </div>
                    </ng-container>

                    <ng-container *ngIf="renderedLabels.length > 0">
                        <div (click)="deleteAll()" class="clear-all">Clear all</div>
                    </ng-container>
                </div>
                <span class="search-result-count justify-content-between">
                    <div class="search-result-count-info"
                         data-testid="search-result-count-mobile"
                         *ngIf="isSuggestingKeyword()"
                    >
                        No results for&nbsp;<span>"{{keyword}}"</span>
                    </div>
                    <div class="search-result-count-info"
                         data-testid="search-result-count-mobile"
                         *ngIf="!isSuggestingKeyword()"
                    >
                       <strong>{{totalHits | number}} {{ getResultsLabel() }} "{{keywordUsed}}"</strong>
                    </div>
                    <div *ngIf="isSuggestingKeyword()" class="search-suggested-count" >
                        <span>Showing <strong>{{totalHits | number}}</strong> results for&nbsp;<strong>"{{keywordUsed}}"</strong> </span>
                        <div class="tf-ng-popover" [ngbPopover]="searchTipsRef" placement="bottom" [popoverClass]="getSearchTipClass()">
                            <svg  xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 16 16">
                                <path d="M9,4c2.8,0,5,2.2,5,5s-2.2,5-5,5s-5-2.2-5-5S6.2,4,9,4 M9,2C5.1,2,2,5.1,2,9s3.1,7,7,7s7-3.1,7-7c0-1.9-0.7-3.6-2.1-4.9S10.9,2,9,2z M8,8.5v4.4h2V8.5H8z M8,5.2v2h2v-2H8z"/>
                            </svg>
                        </div>
                    </div>
                    <div *ngIf="shouldDisplaySimilarSearches()" class="tf-similar-searches-assays-ctnr">
                        <div class="one-line">Similar searches:</div>
                        <div class="tf-unified-card-result-data tf-similar-searches-assays" *ngFor="let value of suggestedKeywordsArray; last as isLast ; index as i">
                            <div *ngIf="getLastSeparator(isLast)" class="tf-suggested-keyword-last">or</div>
                            <div (click)="redirect(value)" class="tf-suggested-keyword-value">{{ value }}</div>
                            <div *ngIf="getSeparator(i)" class="tf-unified-card-separator">,</div>
                        </div>
                    </div>
                    <div class="d-md-none mobile-v">
                        <ng-content select="[mobileVersion]"></ng-content>
                    </div>
                </span>
            </div>

            <div class="tf-filter-desktop d-none d-md-flex" [ngClass]="suggestedKeywordClass()"  >
                <div class="summary">
                    <div class="search-result-count-info"
                         data-testid="search-result-count"
                         style="margin-bottom: 16px"
                         *ngIf="isSuggestingKeyword()"
                    >
                        No results for <span> &nbsp;"{{keyword}}"</span>
                    </div>
                    <div class="search-result-count-info"
                         data-testid="search-result-count"
                         *ngIf="!isSuggestingKeyword()"
                    >
                        <strong>{{totalHits | number}}&nbsp; results for "{{ keywordUsed }}"</strong>
                    </div>
                    <div class="search-result-suggestions">
                        <div *ngIf="isSuggestingKeyword()" class="search-suggested-count">
                            <span>Showing <strong>&nbsp;{{totalHits | number}}&nbsp;</strong> {{getResultsLabel()}} <strong>&nbsp;{{ keywordUsed }}.&nbsp;</strong></span>
                        </div>
                        <div *ngIf="shouldDisplaySimilarSearches()" class="tf-similar-searches-assays-ctnr">
                            <div class="one-line">Similar searches:</div>
                            <div class="tf-unified-card-result-data tf-similar-searches-assays" *ngFor="let value of suggestedKeywordsArray; last as isLast ; index as i">
                                <div *ngIf="getLastSeparator(isLast)" class="tf-suggested-keyword-last">or</div>
                                <div (click)="redirect(value)" class="tf-suggested-keyword-value">{{ value }}</div>
                                <div *ngIf="getSeparator(i)" class="tf-unified-card-separator">,</div>
                            </div>.
                            <div class="tf-ng-popover" [ngbPopover]="searchTipsRef" placement="bottom" [popoverClass]="getSearchTipClass()">
                                <svg  xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 16 16">
                                    <path d="M9,4c2.8,0,5,2.2,5,5s-2.2,5-5,5s-5-2.2-5-5S6.2,4,9,4 M9,2C5.1,2,2,5.1,2,9s3.1,7,7,7s7-3.1,7-7c0-1.9-0.7-3.6-2.1-4.9S10.9,2,9,2z M8,8.5v4.4h2V8.5H8z M8,5.2v2h2v-2H8z"/>
                                </svg>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="filter-container">
                    <div class="filter-items" *ngFor="let filter of items; index as i">
                        <div [ngClass]="isAssay() && isPopover(filter.productSubType, filter.name) && 'assay-design'">
                            <tf-multi-select
                                [options]="filter.navigators"
                                [overlayVisible]="filter.overlayVisible"
                                [searchInputValue]="filter.searchInputValue"
                                [isServerSideSearch]="filter.isServerSideSearch"
                                [allowOnlyOne]="filter.allowOnlyOne"
                                [isLoadingData]="filter.isLoading"
                                [selectedOptions]="filter.selectedOptions"
                                [searchPlaceHolder]="getSearchPlaceholder(filter.name)"
                                [hasClearBtn]="hasClearBtn(filter.productSubType, filter.name)"
                                [disable]="filter.disabled"
                                optionLabel="app"
                                overlayWidth="160px"
                                [defaultLabel]="filter.name"
                                [isCondensed]="true"
                                [search]="filter.hasSearch"
                                [virtualScroll]="this.hasVirtualScroll(filter.productSubType, filter)"
                                (onChange)="onChange($event, i)"
                                (onClosed)="onClosed()"
                                (onSearch)="handleSearch($event, i, filter.queryName)">
                            </tf-multi-select>

                            <ng-container *ngIf="isAssay()">
                                <div *ngIf="isPopover(filter.productSubType, filter.name)"
                                     class="tf-ng-popover ps-1"
                                     [ngbPopover]="getPopoverContentRef(filter.productSubType, filter.name)"
                                     [placement]="['bottom', 'right-top']"
                                     [popoverClass]="getPopoverClass(filter.productSubType, filter.name)">
                                    <svg  xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 16 16">
                                        <path d="M9,4c2.8,0,5,2.2,5,5s-2.2,5-5,5s-5-2.2-5-5S6.2,4,9,4 M9,2C5.1,2,2,5.1,2,9s3.1,7,7,7s7-3.1,7-7c0-1.9-0.7-3.6-2.1-4.9S10.9,2,9,2z M8,8.5v4.4h2V8.5H8z M8,5.2v2h2v-2H8z"/>
                                    </svg>
                                </div>
                            </ng-container>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="d-none d-md-flex">
            <ng-content select="[desktopVersion]"></ng-content>
        </div>

        <ng-template #geCrossReactivity><b>Transgenic cross-reactivity check</b><br /><br />
            Select the species that you do not want your assay to detect.<br />
            Assays that remain in the filtered search results will not exhibit species cross-reactivity and thus are suitable to use in transgenic experiments.
        </ng-template>

        <ng-template #geAttributes>
            <b>About assay attributes</b> <br /><br />
            <b>Recommended products</b> are evaluated by a proprietary bioinformatic algorithm with additional criteria.<br /><br />
            <b>3’ most</b> assay design reveals where the primers and probe are located within the exon structure of the transcript.<br /><br />
            <b> Qualified </b>is functionally tested with pathogen-containing samples.<br /><br />
            <b> Non-standard annotation</b> captures assays that don't map to the typical eukaryotic coding region of a transcript. This applies to many microbial assays and fusion constructs.<br /><br />
            Learn more about an assay’s design in its Details panel.<br /><br />
            For more information, please see <a href="https://tinyurl.com/tt8v9ukv" target="_self">here</a> or contact
            <a href="/us/en/home/technical-resources/contact-us.4331182.html?supportType=TS" target="_self">Tech Support.</a>
        </ng-template>

        <ng-template #geAttributesFS>
            <b>About assay attributes</b> <br /><br />
            <b>Recommended products</b> are evaluated by a proprietary bioinformatic algorithm with additional criteria.<br /><br />
            <b>3’ most</b> assay design reveals where the primers and probe are located within the exon structure of the transcript.<br /><br />
            <b> Qualified </b>is functionally tested with pathogen-containing samples.<br /><br />
            <b> Non-standard annotation</b> captures assays that don't map to the typical eukaryotic coding region of a transcript. This applies to many microbial assays and fusion constructs.<br /><br />
            Learn more about an assay’s design in its Details panel.<br /><br />
            For more information, contact
            <a href="/us/en/customer-help-support.html?cid=OBC_INT_20200507_XTD27A" target="_self">Tech Support.</a>
        </ng-template>

        <ng-template #snpAssayType>
            <b>Assay Types</b> <br /><br />
            <b>Functionally Tested</b><br />
            Functionally Tested Assays meet minimum functionality criteria in testing of 20 gDNA samples, from three ethnic populations and both genders, before shipment upon first order. Minor allele frequency is not calculated.
            <br /><br />
            <b>DME</b><br />
            TaqMan® Drug Metabolism Enzyme Assays are tested using gDNA from 45 individuals from four ethnicities. The minor allele frequency for each population is available, but rare and mutant alleles may not be present in the test DNA.
            <br /><br />
            <b>Validated</b><br />
            Validated Assays are tested using gDNA from 45 individuals from four ethnicities. The minor allele frequency for each population is available and is shown to be >5% in at least one population.
            <br /><br />
            <b>Qualified</b><br />
            Qualified Assays are pre-tested using cell line and tissue gDNAs and/or synthetic templates to meet specific functionality requirements.<br /><br />
        </ng-template>

        <ng-template #searchTips>
            <div class="tf-popover-title">
                <b>Search Tips</b>
            </div>
            <div class="tf-popover-content">
                <b class="tf-popover-subtitle">&#x2022; Modify the search and try again</b><br/>
                <div class="tf-popover-text">
                    Spelling or typing errors.<br/>
                </div>
                <b class="tf-popover-subtitle">&#x2022; Try searching for synonyms</b><br/>
                <div class="tf-popover-text">
                    The assay is listed under an alternate gene/protein name.<br/>
                </div>
                <b class="tf-popover-subtitle">&#x2022; Remove the species to search by Assay ID</b><br/>
                <div class="tf-popover-text">
                    The Assay ID entered does not match the selected species.<br/>
                </div>
                <b class="tf-popover-subtitle">&#x2022; Try a different application</b><br/>
                <div class="tf-popover-text">
                    The query matches other Predesigned TaqMan product types.<br/>
                </div>
            </div>
        </ng-template>


    </div>
    <div class="d-block container-fluid">
        <tf-selected-filters></tf-selected-filters>
    </div>
</div>
